import { render, staticRenderFns } from "./ExtratoDeSolicitacao.vue?vue&type=template&id=0cd2acd4"
import script from "./ExtratoDeSolicitacao.vue?vue&type=script&lang=js"
export * from "./ExtratoDeSolicitacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports